<script>
  import Link from "../../shared/Link.svelte";
  import Matrix from "../../shared/Matrix.svelte";
  import { _ } from "svelte-i18n";

  const matrix1 = [
    [1, 4, 2, 1],
    [3, 0, 3, 1],
    [5, 1, 2, 0],
    [4, 1, 2, 3],
  ]
  const matrix2 = [
    [-3, 2, 2, 2],
    [0, -3, 2, 2],
    [0, 0, -3, 2],
    [0, 0, 0, -3],
  ]
</script>

<div class="title">
  <h2>{$_("lesson-xR66u.h2-0")}</h2>
</div>
<hr />
<div class="text">
  <p>
    {$_("lesson-xR66u.p-0")}
  </p>
  <div align="center"><img width="700" src="/img/Process.png" alt="A Hamilton matrix titled Input points to the D-Wave Advantage quantum annealer points to a vector titled Output"></div>
  <p>
    {$_("lesson-xR66u.p-1")}
  </p>
  <h3>{$_("lesson-xR66u.h3-0")}</h3>
  <p>
    {@html $_("lesson-xR66u.p-2-0")}
    {`$$\\vec{ q }=\\begin{pmatrix}q_1 \\\\ q_2 \\\\ q_3\\end{pmatrix}$$`}
    {@html $_("lesson-xR66u.p-2-1")}
    {`$$\\vec{q}_A = \\begin{pmatrix}a \\\\ b \\\\ \\vdots \\\\ n\\end{pmatrix} = \\begin{pmatrix}0 \\\\ 1 \\\\ \\vdots \\\\ 1\\end{pmatrix}$$`}
    {@html $_("lesson-xR66u.p-2-2")}
  </p>
  <Matrix size="200" data={matrix1} showLabels={false}/>
  <p>
    {@html $_("lesson-xR66u.p-3")}
  </p>
  <p>
    {$_("lesson-xR66u.p-4-0")}
    {`$$f\\left(a,b,c,d\\right)=h_aa+h_bb+h_cc+h_dd+h_{ab}ab+h_{ac}ac+h_{ad}ad+h_{bc}bc+h_{bd}bd+h_{cd}cd$$`}
    {`$$\\Rightarrow H=\\begin{pmatrix}h_a & h_{ab} & h_{ac} & h_{ad} \\\\ 0 & h_b & h_{bc} & h_{bd} \\\\ 0 & 0 & h_c & h_{cd} \\\\ 0 & 0 & 0 & h_d\\end{pmatrix}$$`}
    {@html $_("lesson-xR66u.p-4-1")}
    {`$$f\\left(a,b,c,d\\right)=-3a-3b-3c-3d+2ab+2ac+2ad+2bc+2bd+2cd\\Rightarrow$$`}
  </p>
  <Matrix size="150" data={matrix2} showLabels={false}/>
  <p>
    {@html $_("lesson-xR66u.p-5-0")}
    {`$$\\min C\\left(q\\right)=\\min_{q_i=0,1}\\left(\\sum_{i=1}^{N}a_iq_i+\\sum_{i<j}^{N}b_{ij}q_iq_j\\right)=\\min\\left(\\vec{q}^TH\\vec{q}\\right)$$`}
    {@html $_("lesson-xR66u.p-5-1")}
  </p>
  <div align="center"><strong>{$_("lesson-xR66u.strong-0")}</strong></div>
  <h3>{$_("lesson-xR66u.h3-1")}</h3>
  <p>
    {$_("lesson-xR66u.p-6")}
  </p>
  <div style="float: right"><img width="150" src="/img/Qpu.png" alt="A quantum processing unit on a chipset"></div>
  <p>
    {@html $_("lesson-xR66u.p-7")}
  </p>
  <p>
    {@html $_("lesson-xR66u.p-8")}
  </p>
  <div align="center"><img width="600" src="/img/ChimeraPegasus.png" alt="Dots connected by lines to represent the QPU topology of the D-Wave quantum annealers"><br><i>{$_("lesson-xR66u.i-0")}<sup>4</sup></i></div>
  <p>
    {@html $_("lesson-xR66u.p-9")}
  </p>
</div>
<hr>
<div class="refs">
  <h3>{$_("references")}</h3>
  <ol>
    <li><Link target="https://en.wikipedia.org/wiki/Vector_(mathematics_and_physics)" newPage={true}>https://en.wikipedia.org/wiki/Vector_(mathematics_and_physics)</Link>, {$_("ref_access")}: 18.03.2022</li>
    <li>M. Willsch, D. Willsch, K. Michielsen. <i>Lecture notes: Programming Quantum Computers</i>. arXiv: 2201.02051 (2022), {$_("ref_access")}: 19.03.2022</li>
    <li>Fiona H, <i>New QPU Solver: Advantage Performance Update</i>, (2021), <Link target="https://support.dwavesys.com/hc/en-us/articles/4410049473047-New-QPU-Solver-Advantage-Performance-Update" newPage={true}>https://support.dwavesys.com/hc/en-us/articles/4410049473047-New-QPU-Solver-Advantage-Performance-Update</Link>, {$_("ref_access")}: 20.03.2022</li>
    <li>Fig. 2, C. Gonzales Calaza, D. Willsch, K. Michielsen. <i>Garden optimization problems for benchmarking quantum annealers</i>. arXiv: 2101.10827 (2021), {$_("ref_access")}: 20.03.2022</li>
  </ol>
</div>

<style>
  .title h2, .refs h3 {
    background: -webkit-linear-gradient(90deg, #1a91bc, #2eb6e8);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  hr {
    border: 1px solid white;
    border-top: 1px solid #ddd;
    margin: 20px auto;
  }
</style>
